export const VARS = [
  "{FirstName}",
  "{LastName}",
  "{CustomerContact}",
  "{Birthday}",
  "{CountryName}",
  "{TotalOrderCount}",
  "{TotalOrderValue}",
  "{LastTransactionDate}",
  "{RegistrationDate}",
  "{MemberTier}",
  // "{BrandName}",
  // "{StoreName}",
  "{MemberPointBalance}",
  "{MemberPointBalanceExpiring}",
  "{MemberPointBalanceNextExpiryDate}",
  "{MemberBalanceVoucher}",
  "{NearestVoucherExpiryDate}",
  "{VoucherName}",
  "{VoucherExpiry}",
];
